import React, { FC } from 'react';
import VideoPlayer from '../../../components/VideoPlayer';
import ArrowBtn from '../../../components/ArrowBtn';
import styles from './AIProductIntro.module.scss';
import { useVideoManager } from '../../../hooks/useVideoManager';

interface FeatureItem {
  /** 特性标题 */
  title: string;
  /** 特性描述 */
  description: string;
}

interface Props {
  /** 视频封面图 */
  poster: string;
  /** 视频源地址 */
  videoSource: string;
  /** 产品标题（数组，支持多行） */
  titles: string[];
  /** 产品口号 */
  slogan: string;
  /** 特性列表 */
  features: FeatureItem[];
  /** 按钮文本 */
  buttonText: string;
  /** 按钮链接 */
  buttonUrl: string;
  /** 是否外部链接 */
  linkOut?: boolean;
  /** 自定义类名 */
  className?: string;
}

/**
 * AI 产品介绍组件
 * 展示 AI 产品的介绍视频和特性说明，支持根据数据动态展示不同的 AI 产品
 */
const AIProductIntro: FC<Props> = (props) => {
  const {
    poster,
    videoSource,
    titles,
    slogan,
    features,
    buttonText,
    buttonUrl,
    linkOut = false,
    className = '',
  } = props;

  const { registerAndPauseOthers } = useVideoManager();

  return (
    <div className={`${styles['ai-product-intro']} ${className}`}>
      <div className={styles['ai-wrapper']}>
        <div className={styles['ai-video-wrapper']}>
          <VideoPlayer poster={poster} showBigButton source={videoSource} onPlay={registerAndPauseOthers} />
        </div>
        <div className={styles['ai-content-wrapper']}>
          {titles.map((title, index) => (
            <div key={index} className={styles['ai-content-title']}>
              {title}
            </div>
          ))}
          <div className={styles['ai-content-slogan']}>{slogan}</div>
          <ul className={styles['ai-content-ul']}>
            {features.map((feature, index) => (
              <li key={index}>
                <div>
                  <span className={styles['ai-content-li-title']}>{feature.title}</span>
                  {feature.description}
                </div>
              </li>
            ))}
          </ul>
          <div className={styles['ai-content-button']}>
            <ArrowBtn linkVal={buttonText} linkUrl={buttonUrl} linkOut={linkOut} />
          </div>
        </div>
      </div>
    </div>
  );
};

AIProductIntro.displayName = 'AIProductIntro';
export default AIProductIntro;
